(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dorrara-film"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("click",(event)=>{const player=event.target.closest('.dorrara-film-player[data-click-sound="true"]');if(!player)return;const video=player.querySelector("video"),button=player.querySelector(".dorrara-film-sound");if(!video||!button)return;if(event.target.closest(".dorrara-film-sound")){video.muted=!video.muted;if(video.paused)video.play().catch(()=>{});}else if(event.target===video){video.muted=false;}else{return;}button.setAttribute("aria-pressed",String(!video.muted));button.textContent=video.muted?button.dataset.soundOn:button.dataset.soundOff;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
